import * as React from 'react';
const CelluliteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M125.13 59.17V73.3c0 6.41 10.99 18.32 10.99 36.12 0 15.05-3.14 31.41-3.14 31.41M74.87 59.17V73.3c0 6.41-10.99 18.32-10.99 36.12 0 15.05 3.14 31.41 3.14 31.41M85.87 128.27c6.02 0 14.13-1.57 14.13-18.85 0 17.28 8.11 18.85 14.13 18.85M100 109.42v-3.14M103.14 123.37v17.46M96.86 123.37v17.46"
      className="prefix__cls-2"
    />
    <path
      d="M80.54 121.83s5.8.24 8.77-2.49M108.97 114.61s5.16 2.89 9.99 1.74M119.39 123.37s4.15.95 7.58-.7M76.99 134.27s3.78 3.32 8.88 2.61"
      className="prefix__cls-1"
    />
  </svg>
);
export default CelluliteIcon;
